import React, { useContext } from "react";
import * as Yup from "yup";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { ServiceContactForm } from "../../../types/types";
import { sendServiceContactFormData } from "../../../service/service";
import { toast } from "react-toastify";
import { AuthContext } from "../../../context/AuthContext";
import PrimaryButton from "../PrimaryButton";
import bg from "../../../assets/svgs/contactbg.svg"

const CommonForm = ({title}: {title: string}) => {
  const dataContext = useContext(AuthContext);

  const SubscribeSchema = Yup.object<ServiceContactForm>({
    name: Yup.string().required("Name is required"),
    phoneNumber: Yup.string().required("Phone Number is required"),
    email: Yup.string().email("Invalid email").required("Email is required"),
  });

  const initialVal: ServiceContactForm = {
    name: "",
    phoneNumber: "",
    email: "",
    title: title,
  };

  const handleSubmit = async (
    values: ServiceContactForm,
    setSubmitting: (isSubmitting: boolean) => void
  ) => {
    try {
      setSubmitting(true);
      const res = await sendServiceContactFormData({
        ...values,
        from: "services",
      });
      if (!res.status) {
        toast.error("Failed to Submit, please try again later.");
        return;
      }

      const resData = res.response?.data;
      if (resData.status) {
        toast.success(resData.message);
      } else {
        toast.error(resData.message);
      }
    } catch (error) {
      setSubmitting(false);
      toast.error("Failed to Submit, please try again later.");
    } finally {
      setSubmitting(false);
    }
  };

  if (!dataContext) return null;
  const { theme } = dataContext;

  return (
    <div
      className={`${
        theme === "dark" ? "bg-white text-black" : "bg-black text-white"
      } transition-all duration-500 py-5 sm:py-14 px-5 sm:px-14 rounded-3xl relative border-[#A1A1A1] border`}
    >
      <Formik
        initialValues={initialVal}
        enableReinitialize
        validationSchema={SubscribeSchema}
        onSubmit={(values, { setSubmitting }) => {
          handleSubmit(values, setSubmitting);
          setSubmitting(false);
          alert(`Thank you for Contacting, ${values.email}`);
        }}
      >
        {({ isSubmitting }) => (
          <Form className="flex flex-col justify-center w-full">
            {isSubmitting ? (
              <div className="text-center">Submitting...</div>
            ) : (
              <>
                <div className="mb-8 w-full lg:grid gap-4">
                  <h4 className="bricolage-grotesque-semibold text-gradient">
                    Have any idea to discuss?
                  </h4>
                  <div className="w-full relative z-10">
                    <Field
                      type="text"
                      name="name"
                      id="name"
                      placeholder="Enter your Name"
                      className={`${
                        theme === "dark"
                          ? "border-black"
                          : "border-white"
                      } block w-full  py-4 px-3 border-b bg-transparent sm:text-sm relative z-10 transition-all duration-500`}
                      required
                    />
                    <ErrorMessage name="name" />
                  </div>
                  <div className="w-full relative z-10">
                    <Field
                      type="text"
                      name="email"
                      id="email"
                      placeholder="Enter Your Email"
                      className={`${
                        theme === "dark"
                          ? "border-black"
                          : "border-white"
                      } block w-full py-4 px-3 border-b bg-transparent  sm:text-sm relative z-10 transition-all duration-500`}
                      required
                    />
                    <ErrorMessage name="email" />
                  </div>
                  <div className="w-full relative z-10">
                    <Field
                      type="text"
                      name="phoneNumber"
                      required
                      id="phoneNumber"
                      placeholder="Enter Your Phone Number"
                      className={`${
                        theme === "dark"
                          ? "border-black"
                          : "border-white"
                      } block w-full py-4 px-3 border-b  bg-transparent sm:text-sm relative z-10 transition-all duration-500`}
                    />
                    <ErrorMessage name="phoneNumber" />
                  </div>
                </div>
                <PrimaryButton
                  type="submit"
                  disabled={isSubmitting}
                  className={`${
                    theme === "dark"
                      ? "bg-primary border-primary"
                      : "bg-secondary border-secondary"
                  } relative border border-opacity-50 text-white justify-center z-10`}
                >
                  Submit
                </PrimaryButton>
              </>
            )}
          </Form>
        )}
      </Formik>
      {theme === 'dark' ? null : (
        <img src={bg} className="absolute top-0 right-0" alt=""/>
      )}
    </div>
  );
};

export default CommonForm;
